(function ($) {
	// On Dom Ready
	$(function () {
		// Tabs
		$("ul.tab-links a").on("click", function (e) {
			e.preventDefault();
			$(this).addClass("active");
			$(this).parent().siblings().find("a").removeClass("active");
			const tabId = $(this).data("tab-link");

			$(".tab-content").hide();
			$(".tab-content.tab-" + tabId).fadeIn();


			if($(this).closest('ul.tab-links').hasClass('sticky-tabs')) {
				document.querySelector('.site-content-inner').scrollIntoView();
			}
		});

		// Tabs inside content (mobile)
		$(".site-content .tab-link-content-area").on("click", function (e) {
			e.preventDefault();
			$(".tab-content").hide();
			const tabId = $(this).data("tab-link");

			if ($(this).hasClass("active")) {
				$(this).removeClass("active");
				$(".tab-content.tab-" + tabId).fadeOut();
			} else {
				$(this).addClass("active");
				$(".tab-content.tab-" + tabId).fadeIn();
			}
			$(this).siblings().removeClass("active");
			/* $(this).addClass("active");
			$(this).parent().siblings().find("a").removeClass("active"); */
		});
	});

	const tabLinks = $('ul.tab-links');
	tabLinks.before('<div class="tab-links-sentinel"></div>');

	const tabLinksObserver = new IntersectionObserver(function (entries, observer) {
		if (!entries[0].isIntersecting) {
			tabLinks.addClass('sticky-tabs');
		} else {
			tabLinks.removeClass('sticky-tabs');
		}
	}, {
		//rootMargin: '200px 0px 0px',
	});
	function observeTheTabLinks() {
		if(document.querySelector('.tab-links-sentinel')) {
			tabLinksObserver.observe(document.querySelector('.tab-links-sentinel'));
		}
	}
	observeTheTabLinks();

})(jQuery);
